/**
 * @generated SignedSource<<ff99754e3fe5b1b300ec43954f83945a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedSiblingDesigns_designPageInfo$data = {
  readonly design: {
    readonly parent: {
      readonly browsePageLinkData: {
        readonly isLinkable: boolean | null;
        readonly path: string | null;
      };
      readonly displayName: string | null;
    } | null;
  } | null;
  readonly siblingDesigns: ReadonlyArray<{
    readonly browsePageImage: string | null;
    readonly browsePageLinkData: {
      readonly isLinkable: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly displayName: string | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedSiblingDesigns_designPageInfo";
};
export type SbSharedSiblingDesigns_designPageInfo$key = {
  readonly " $data"?: SbSharedSiblingDesigns_designPageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedSiblingDesigns_designPageInfo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedSiblingDesigns_designPageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "design",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesign",
          "kind": "LinkedField",
          "name": "parent",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "browsePageLinkData",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                },
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "siblingDesigns",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browsePageImage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "browsePageLinkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DesignPageInfo",
  "abstractKey": null
};
})();

(node as any).hash = "25e26439172bd0bac0bee84a93f3ece8";

export default node;
